import { gql } from 'graphql-request';

const FORM_WRAPPER_FIELDS = gql`
  fragment formWrapper on ComponentMiscComponentsCustomFormWrapper {
    title
    title_en
    title_nl
    description
    description_en
    description_nl
    positionNo
    disableValidation
    isRoutingUrlForm
    routingUrlKey
    routingStaticUrl
    isConditionalForm
    conditionalKey
    conditionalValue
    conditionalOperator
    conditionalFieldType
    hidden
    key
    conditions {
      ...formCondition
    }
    onChangeApiCalls {
      title
      api_call {
        ...formApiCall
      }
      dependentKeys {
        key
        notRequired
      }
    }
    onLoadApiCalls {
      ...formApiCall
    }
    form {
      ...form
    }
    validations {
      ...formCondition
    }
  }
`;

// export default FORM_WRAPPER_FIELDS;
// exports.default = FORM_WRAPPER_FIELDS;
export default FORM_WRAPPER_FIELDS;
